import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { createRoot } from 'react-dom/client';
import { ensureTourRoot } from '@digiwedge/tour-shadow';
import { TourOverlay } from './Overlay.js';
/**
 * Mounts a React root into the Shadow DOM host for the tour UI.
 * Place once, near the app root.
 */
export function DomPortalForTour() {
    const rootRef = useRef(null);
    useEffect(() => {
        const { mount } = ensureTourRoot();
        const mountWithRoot = mount;
        const existing = mountWithRoot.__tourReactRoot__;
        const root = existing ?? createRoot(mount);
        if (!existing) {
            mountWithRoot.__tourReactRoot__ = root;
        }
        rootRef.current = root;
        root.render(_jsx(TourOverlay, {}));
        return () => {
            rootRef.current = null;
        };
    }, []);
    return null;
}
//# sourceMappingURL=DomPortalForTour.js.map